'use client';
import { useEffect } from 'react';
import { useModalContext } from '../../../Modal.context.js';

function useModalTitleId() {
    const context = useModalContext();
    useEffect(()=>{
        context.setTitleMounted(true);
        return ()=>context.setTitleMounted(false);
    }, []);
    return context.getTitleId();
}

export { useModalTitleId };
//# sourceMappingURL=useModalTitleId.js.map
